<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" style="max-width:90% !important" v-bind:style="ContainerPadding">
                    <div class="row align-items-lg-center">
                        <div class="col-lg-5 mb-5 mb-lg-0 mb-10">
                            <div class="mb-5">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="display-4 text-dark mb-5" :init="EditorConfig" keyDown v-model="BlockProps.Header" tag-name="h1">
                                </omnieditor>

                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="fs-3" tag-name="p" :init="EditorConfig" keyDown v-model="BlockProps.Leadin">
                                </omnieditor>

                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" :init="EditorConfig" keyDown v-model="BlockProps.Content">
                                </omnieditor>

                            </div>


                            <div class="position-relative" style="top:20px;">
                                <!-- Input Card -->
                                <label class="fw-bold p-1">&nbsp; Enter Address To Verify Service Area<sup>*</sup></label>
                                <div class="input-card input-card-sm">

                                    <div class="input-card-form">
                                        <label for="searchForm" class="form-label visually-hidden">full address</label>
                                        <input v-model="StartAddress" type="text" class="form-control form-control-lg" id="searchForm" placeholder="full address" aria-label="full address">
                                    </div>
                                    <button v-on:click="CheckServiceArea" type="button" class="btn btn-primary btn-lg btn-pointer">Check</button>
                                </div>
                                <div class="blink text-red fw-bold text-center mt-2" v-if="StartError">{{StartError}}</div>
                                <!-- End Input Card -->

                            </div>

                        </div>
                        <!-- End Col -->

                        <div class="col-lg-6">
                            <div class="position-relative">
                                <div class="position-relative p-1">
                                    <img class="img-fluid rounded-4 shadow-sm" :src="BlockProps.Img1" alt="Mobile Notary Service">
                                </div>



                            </div>
                        </div>
                        <!-- End Col -->
                    </div>
                    <!-- End Row -->

                    <div class="row align-items-center mt-4">
                        <div class="col col-12 text-muted fs-6 pl-1" style="font-size:10px;font-style:italic">
                            <sup>*</sup>Mobile In-Person Notary services are offered at <span class="fw-bold text-primary">Commercial</span><span v-if="NotaryConfig.allowResidentialSignings"><span class="fw-bold text-primary"> and Residential</span></span> locations<span v-if="!NotaryConfig.allowResidentialSignings"> only</span>.
                            <br />
                            <span v-if="!NotaryConfig.offerLoanClosings && Store.TenantConfig.serviceConfigNotary && Store.TenantConfig.serviceConfigNotary.offerLoanClosings"><sup>*</sup><span class="fw-bold text-primary">Loan Signings</span> are not available for in-person 'wet signature' service. Loan Signings are only available with our Remote Electronic Notarization service.</span>

                            <span v-if="!NotaryConfig.offerLoanClosings && (!Store.TenantConfig.serviceConfigNotary || !Store.TenantConfig.serviceConfigNotary.offerLoanClosings)"><sup>*</sup><span class="fw-bold text-primary">Loan Signings</span> are not available for in-person 'wet signature' service are not available with this service.</span>
                        </div>

                    </div>
                    <div class="row align-items-center mt-4">
                        <div class="col col-12 text-muted fs-6 pl-1" >
                            
                        </div>
                        <div class="col col-12 text-muted fs-6 pl-1" >
                            
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <small style="font-size:12px;"><i class="bi bi-info-circle"></i>  Highlight Image (75kb max)</small>
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <div class="row">
                            <div class="col col-12 text">
                                <div style="display:inline-block; width: 100px !important;height: 75px !important;">
                                    <img style="object-fit:cover; width:100% !important; height:100% !important;object-position:center  !important;box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; border: 1px solid black" :src="BlockProps.Img1" alt="Image1" />
                                </div>
                                <i class="bi bi-chevron-double-right"></i>
                                <button @click="UploadNewSlideBackground(1)" type="button" style="margin-left:5px;" class="btn btn-sm btn-primary"><i class="bi bi-image"></i> Change Image</button>
                            </div>
                            <hr style="margin-top: 5px; margin-bottom:5px;" />
                        </div>


                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>

        <div style="z-index:300" id="MessageModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="Modal Message" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="text-center" style="margin: 0 auto !important;">
                            <h4 class="modal-title h4 text-center" style="margin: 0 auto !important;" v-html="ModalTitle"></h4>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-2">
                            <div class="col text-muted" style="font-size:14px;">
                                {{Msg}}
                            </div>
                        </div>
                        <div class="row mb-5 text-center justify-content-center">
                            <div class="col-md-6 text-center justify-content-center">
                                <div class="d-grid gap-2">
                                    <a class="btn btn-sm btn-primary shadow btn-block btn-pointer" href="/content/checkout">Schedule Notary </a>
                                </div>
                            </div>
                        </div>
                        <div class="row ">
                            <div class="col-md-12">
                                <div class="border-1 shadow-sm">
                                    <iframe style="border:0;width:100%;height:400px"
                                            loading="lazy"
                                            allowfullscreen
                                            referrerpolicy="no-referrer-when-downgrade"
                                            :src="PlaceMapSrc">
                                    </iframe>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import axios from '/src/components/NovaAxios.js';
    import { toast } from 'vue3-toastify';


    export default {
        inheritAttrs: false,
        name: 'MobileNotaryEstimate',
        mixins: [ContentBlockBase],
        props: ['notaryconfig'],
        components: {
        },
        computed:
        {
           NotaryConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.notaryconfig) {
                    return this.notaryconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigMobileNotary) {
                    return this.Store.TenantConfig.serviceConfigMobileNotary;
                }               
            }
        },
        data() {
            return {  
                PlaceMapSrc: '',
                StartError: '',
                ModalObj: null,
                ModalTitle: '',
                ModalMessage: '',
                StartAddress: '',
                MapDistance: 0,
                Msg: '',
                MapCost: 0,
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#NotarySettings'
            };
        },
        methods:
        {
            OnSlideImageUploaded: function (args) {
                if (args.success)
                {
                    if (this.BlockProps[args.idx] && args.url){
                        this.BlockProps[args.idx] = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            UploadNewSlideBackground: function(idx){
                this.HideEditProperties();
                var args = {};  

                var imgProp = 'Img' + idx;
                args.ExistingFileURL = this.BlockProps[imgProp];
                args.CompleteCallback = "OnSlideImageUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = { MaxSize: 1024 * 75, idx: imgProp, url: ''}; // this will be sent back in the callback
                args.Prompt = `Image`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            },
            ShowModal: function (title) {
                 this.ModalTitle = title;
                 this.ModalObj.show();
             },
             CheckServiceArea: async function () {
                 this.StartError = "";
                 if (!this.StartAddress) {
                     await nextTick()
                     this.StartError = "Address can't be blank.";
                     return;
                 }
                 this.IsLoading = true;
    
                 const start = this.StartAddress;

                 await this.ValidateAndDisplayAddress(start, this.ServiceArea);               

                 this.IsLoading = false;
             },
         
       
             ValidateAndDisplayAddress: async function(start) {
     
                 EventHub.$emit("PageLoading", true);
                 
               
                     var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                     var that = this;
                     // ajax to server to get distance and cost estimate
                     axios.postForm('/API/GetMobileNotaryEstimate', { serviceAddress: start }, {
                         cache: false,
                         headers: {
                             'RequestVerificationToken': token
                         }
                     }).then(function (response) {
                         
                         EventHub.$emit("PageLoading", false);

                         if (response.data.success) {
                             that.MapCost = response.data.travelfee;
                             that.Msg = response.data.msg;
                             that.MapDistance = response.data.miles;
                             that.ModalMessage = "Your Mobile Notary Request Is Within The Available Service Area";                             
                             that.PlaceMapSrc = response.data.mapsrc;

                             that.ShowModal("<span style='color:green'>Travel Estimate <i class='bi-check-circle'></i></span> - Distance " + that.MapDistance + " miles");
                         }
                         else {
                             toast.error(response.data.msg);
                         }
                     }).catch(function (error) {
                         EventHub.$emit("PageLoading", false);
                         toast.error("There was an error. Please refresh the page and try again.");
                     });
                     
                
                
             },
           
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        mounted() {
            this.ModalObj = new bootstrap.Modal(document.getElementById('MessageModal'));
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

